import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import FavoritesItem from '../../components/global/FavoriteIcons/FavoritesItem';
import FavoritesProvider from '../../components/global/FavoriteIcons/FavoritesProvider';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';

export function PdpSharedSidebarFavorites(props) {
    const {
        isClient,
        itemId,
        environment,
        itemTitle,
        itemImage,
        wrapperClass,
        heartIconWrapperClass,
        folderIconWrapperClass,
        viewer,
        user,
        fetchFavorites,
        hasFetchedOnClient,
    } = props;
    return (
        <FavoritesProvider
            environment={environment}
            location={locations.SIDEBAR}
            disable={!isClient || !hasFetchedOnClient}
            userId={user && user.serviceId ? user.serviceId : null}
            itemIds={[itemId]}
            shouldAutoFavorite
            viewer={viewer || null}
            fetchFavorites={fetchFavorites}
        >
            {// eslint-disable-next-line
            ({ favorites }) => (
                <FavoritesItem
                    {...favorites}
                    itemId={itemId}
                    itemTitle={itemTitle}
                    itemImage={itemImage}
                    wrapperClass={wrapperClass}
                    heartIconWrapperClass={heartIconWrapperClass}
                    folderIconWrapperClass={folderIconWrapperClass}
                />
            )}
        </FavoritesProvider>
    );
}

PdpSharedSidebarFavorites.defaultProps = {
    hasFetchedOnClient: false,
};

PdpSharedSidebarFavorites.propTypes = {
    hasFetchedOnClient: PropTypes.bool.isRequired,
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    isClient: PropTypes.bool.isRequired,
    item: PropTypes.object,
    wrapperClass: PropTypes.string,
    heartIconWrapperClass: PropTypes.string,
    folderIconWrapperClass: PropTypes.string,
    environment: PropTypes.object.isRequired,
    itemTitle: PropTypes.string,
    itemImage: PropTypes.string,
    viewer: PropTypes.object,
    fetchFavorites: PropTypes.bool,
    user: PropTypes.object,
};

export default createFragmentContainer(PdpSharedSidebarFavorites, {
    viewer: graphql`
        fragment PdpSharedSidebarFavorites_viewer on Viewer {
            ...FavoritesProvider_viewer
        }
    `,
    user: graphql`
        fragment PdpSharedSidebarFavorites_user on User {
            serviceId
        }
    `,
});
